/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx, keyframes } from '@compiled/react';

const rainbowGradientKeyframes = keyframes({
	'0%': {
		opacity: 0.8,
	},
	'20%': {
		opacity: 0.8,
	},
	'40%': {
		opacity: 0.8,
	},
	'60%': {
		opacity: 0.8,
	},
	'80%': {
		opacity: 0,
	},
	'100%': {
		opacity: 0.8,
	},
});

const rainbowGradient = css({
	height: '100%',
	width: '100%',
	background: `conic-gradient(from 270deg at 50% 50%, rgba(24, 104, 219, 0.6) 0deg, rgba(24, 104, 219, 0.6) 143.63999605178833deg, rgba(252, 167, 0, 0.6) 143.66576671600342deg, rgba(252, 167, 0, 0.6) 179.9834668636322deg, rgba(191, 99, 243, 0.6) 180deg, rgba(191, 99, 243, 0.6) 341.9930863380432deg, rgba(130, 181, 54, 0.6) 341.9999957084656deg, rgba(130, 181, 54, 0.6) 359.9645948410034deg, rgba(24, 104, 219, 0.6) 360deg)`,
	backgroundSize: '-150% 250%',
	animation: `${rainbowGradientKeyframes} 2.5s ease-in-out infinite`,
	filter: 'blur(100px)',
});

const container = css({
	height: '100%',
	width: '100%',
	overflow: 'hidden',
});

export const AnimatedLoadingGradient = () => {
	return (
		<div css={container} data-testid="animated-loading-gradient">
			<div css={rainbowGradient} />
		</div>
	);
};
